import { getType, isNull, isNoE, isNoW, padding } from '@/utils/obj-utils';

export const parseDateStr = (str) => {
  let year = null,
    month = null,
    day = null,
    hour = null,
    minute = null,
    second = null;
  let datePart = null,
    timePart = null;
  if (str.indexOf(' ') > 0) {
    [datePart, timePart] = str.split(' ');
  } else {
    datePart = str;
  }
  const matches = /\D/g.exec(datePart);
  if (!matches?.length) return null;
  const separator = matches[0];
  if (/^\d{2}\D\d{2}\D\d{4}$/.test(datePart)) {
    [day, month, year] = datePart.split(separator);
  }
  if (/^\d{4}\D\d{2}\D\d{2}$/.test(datePart)) {
    [year, month, day] = datePart.split(separator);
  }
  if (timePart) {
    [hour, minute, second] = timePart.split(':');
  } else {
    hour = 0;
    minute = 0;
    second = 0;
  }
  return [year, month, day, hour, minute, second];
};
export const parseDate = (str) => {
  const [year, month, day, hour, minute, second] = parseDateStr(str);
  return new Date(year, month - 1, day - 1, hour, minute, second);
};
/**
 * @callback formatDate
 * @property {object} date
 * @property {String} format
 * */
export const formatDate = (date, format = 'yyyy-MM-dd') => {
  if (isNoW(date)) return null;
  const type = getType(date);
  let dateObj = null;
  if (type === '[object Number]') {
    dateObj = new Date(date);
  }
  if (type === '[object Date]') {
    dateObj = date;
  }
  let year = null,
    month = null,
    day = null,
    hour = null,
    minute = null,
    second = null;
  if (type === '[object String]') {
    [year, month, day, hour, minute, second] = parseDateStr(date);
  } else if (
    isNull(dateObj) ||
    getType(dateObj) !== '[object Date]' ||
    dateObj?.toString() === 'Invalid Date'
  ) {
    return null;
  } else {
    year = dateObj.getFullYear();
    month = dateObj.getMonth() + 1;
    day = dateObj.getDate();
    hour = dateObj.getHours();
    minute = dateObj.getMinutes();
    second = dateObj.getSeconds();
  }
  const o = {
    yyyy: year,
    MM: padding(month, 2),
    dd: padding(day, 2),
    HH: padding(hour, 2),
    mm: padding(minute, 2),
    ss: padding(second, 2),
  };
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, (match) => {
    return o[match];
  });
};
export const formatOrderDate = (dateStr, format = 'yyyy-MM-dd') => {
  if (isNoE(dateStr) || dateStr.length < 16) return null;
  const day = Number(dateStr.substring(0, 2)),
    month = Number(dateStr.substring(3, 5)),
    year = Number(dateStr.substring(6, 10)),
    hour = Number(dateStr.substring(11, 13)),
    minutes = Number(dateStr.substring(14, 16));
  return formatDate(new Date(year, month - 1, day, hour, minutes), format);
};
export const getLastDayOfCurrentMonth = (format = 'dd/MM/yyyy') => {
  const date = new Date();
  date.setMonth(date.getMonth() + 1, 0);
  if (format === null) return date;
  return formatDate(date, format);
};
export const formatDateByText = (d, formaMonthTexts) => {
  if (!d) return '';
  d = formatDateCom(d);
  const date = new Date(d);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  return formaMonthTexts[month].fields?.text?.value + ' ' + day + ', ' + year;
};

export const formatDateByiso = (d) => {
  if (!d) return '';
  d = formatDateCom(d);
  console.log(d);
  // const date = new Date(d);
  var date = new Date(d);
  // 设置时间为午夜（00:00:00）
  // date.setHours(0, 0, 0, 0)
  // 转换为ISO字符串，结尾带有'Z'
  const isoString = date.toISOString();
  console.log(isoString); // 输出类似 "2023-10-07T00:00:00.000Z"
  return isoString;
};
export const formatDateCom = (d) => {
  // 分割输入字符串以获取日、月、年部分（日-月-年格式）
  const [day, month, year] = d.split('-').map(Number);

  // 对于月和日，如果长度为1，则在其前面补零
  const formattedMonth = month.toString().padStart(2, '0');
  const formattedDay = day.toString().padStart(2, '0');

  // 组合成符合`YYYY-MM-DD`格式的字符串
  return `${year}-${formattedMonth}-${formattedDay}`;
};

/**
 * 将ISO 8601格式的时间字符串转换为指定格式的日期字符串
 * @param {string} isoString - ISO 8601格式的时间字符串 (例如: "2025-06-30T16:00:00Z")
 * @param {string} format - 目标格式 (默认: "yyyy-MM-dd")
 * @returns {string|null} 格式化后的日期字符串，如果输入无效则返回null
 */
export const formatISOToDate = (date, format = 'yyyy-MM-dd') => {
  const type = getType(date);
  if (['[object String]', '[object Number]'].includes(type)) {
    date = new Date(date);
  }
  if (isNull(date) || getType(date) !== '[object Date]' || date.toString() === 'Invalid Date') {
    return null;
  }
  const year = date.getFullYear(),
    month = date.getMonth() + 1,
    day = date.getDate(),
    hour = date.getHours(),
    minute = date.getMinutes(),
    second = date.getSeconds();
  const o = {
    yyyy: year,
    MM: padding(month, 2),
    dd: padding(day, 2),
    HH: padding(hour, 2),
    mm: padding(minute, 2),
    ss: padding(second, 2),
  };
  return format.replace(/yyyy|MM|dd|HH|mm|ss/g, (match) => {
    return o[match];
  });
};

/**
 * 将ISO 8601格式的时间字符串转换为本地时间的年月日格式
 * @param {string} isoString - ISO 8601格式的时间字符串
 * @param {string} format - 目标格式 (默认: "yyyy年MM月dd日")
 * @returns {string|null} 本地时间格式化后的日期字符串
 */
export const formatISOToLocalDate = (isoString, format = 'yyyy年MM月dd日') => {
  if (isNoW(isoString)) return null;

  try {
    const date = new Date(isoString);

    if (isNaN(date.getTime())) {
      return null;
    }

    // 获取本地时间的年月日
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();

    const o = {
      yyyy: year,
      MM: padding(month, 2),
      dd: padding(day, 2),
      HH: padding(hour, 2),
      mm: padding(minute, 2),
      ss: padding(second, 2),
    };

    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, (match) => {
      return o[match];
    });
  } catch (error) {
    console.error('Invalid ISO date string:', isoString, error);
    return null;
  }
};

export const getOrdinalSuffix = (day) => {
  if (day >= 11 && day <= 13) {
    return 'th';
  }
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

export const formatDateWithOrdinal = (date) => {
  if (isNoW(date)) return '';
  const type = getType(date);
  let dateObj = null;
  if (type === '[object Number]') {
    dateObj = new Date(date);
  } else if (type === '[object Date]') {
    dateObj = date;
  } else if (type === '[object String]') {
    dateObj = new Date(date);
  }
  if (
    isNull(dateObj) ||
    getType(dateObj) !== '[object Date]' ||
    dateObj.toString() === 'Invalid Date'
  ) {
    return '';
  }
  const year = dateObj.getFullYear();
  const month = dateObj.toLocaleString('en-US', { month: 'short' });
  const day = dateObj.getDate();
  const suffix = getOrdinalSuffix(day);
  return `${day}${suffix}, ${month}, ${year}`;
};
